import React from "react";
import { Form, Checkbox, Select, Row, Col } from "antd";
import masterLists from "../../masterLists";

const Section2 = ({ formValues, setFormValues, onNext, loading }) => {
  const countyOptions = ["All Connecticut", ...masterLists.counties];

  const handleCountiesChange = (selected) => {
    const ALL = "All Connecticut";
    const prev = formValues.area || [];
    const hadAll = prev.includes(ALL);
    const hasAll = selected.includes(ALL);

    // 1) User just checked "All Connecticut"
    if (!hadAll && hasAll) {
      setFormValues({ ...formValues, area: countyOptions });
      return;
    }

    // 2) User just unchecked "All Connecticut"
    if (hadAll && !hasAll) {
      setFormValues({ ...formValues, area: [] });
      return;
    }

    // 3) "All Connecticut" still checked but a single county was unchecked
    //    -> drop the "All Connecticut" flag and keep the rest
    if (hadAll && hasAll && selected.length < countyOptions.length) {
      setFormValues({
        ...formValues,
        area: selected.filter((c) => c !== ALL),
      });
      return;
    }

    // 4) Normal multi-select (ensure we don't keep the ALL marker)
    setFormValues({
      ...formValues,
      area: selected.filter((c) => c !== ALL),
    });
  };

  return (
    <Form layout="vertical">
      <Form.Item
        label="10. In which Connecticut counties do you provide marketing services?"
        required
      >
        <Checkbox.Group
          value={formValues.area || []}
          onChange={handleCountiesChange}
        >
          <Row gutter={[0, 8]}>
            {countyOptions.map((county) => (
              <Col span={12} key={county}>
                <Checkbox value={county}>{county}</Checkbox>
              </Col>
            ))}
          </Row>
        </Checkbox.Group>
      </Form.Item>

      <Form.Item
        label="11. What percentage of your work is with clients located in the counties you selected above?"
        required
      >
        <Select
          placeholder="Select percentage"
          value={formValues.localWorkPercent}
          onChange={(val) =>
            setFormValues({ ...formValues, localWorkPercent: val })
          }
        >
          <Select.Option value="76%-100%">
            76%-100% (Most of our business is local/regional)
          </Select.Option>
          <Select.Option value="51%-75%">51%-75%</Select.Option>
          <Select.Option value="26%-50%">26%-50%</Select.Option>
          <Select.Option value="1%-25%">1%-25%</Select.Option>
          <Select.Option value="0%">
            0% (We're looking to expand into these areas)
          </Select.Option>
          <Select.Option value="Not sure">Not sure</Select.Option>
        </Select>
      </Form.Item>

      {/* <Form.Item>
        <Button type="primary" onClick={handleNextClick} loading={loading}>
          Next
        </Button>
      </Form.Item> */}
    </Form>
  );
};

export default Section2;
